Drupal.behaviors.accordions = {
  attach(context) {
    const accordions = Array.from(context.querySelectorAll('[accordion]'));
    const titles = [];



    // ➊ Listen for the Find shortcut and expand all panels
    document.addEventListener('keydown', (e) => {
      // Windows/Linux: Ctrl+F  —  macOS: ⌘+F
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'f') {
        console.log('Find shortcut detected');
        accordions.forEach((accordion) => {
          Array.from(accordion.children)
            .filter(item => item.classList.contains('accordion__item'))
            .forEach((item) => {
              const button = item.querySelector('.accordion__title button');
              item.classList.add('open');
              button.setAttribute('aria-expanded', 'true');
            });
        });
        // allow the browser’s find dialog to appear
        // (no preventDefault or return false)
      }
    });

    function toggleAccordion() {
      const title = this;
      const item = this.closest('.accordion__item');
      const accordion = this.closest('[accordion]');
      const otherItems = Array.from(accordion.children).filter(
        (child) => child !== item,
      );
      const button = title.querySelector('button');
      const isOpen = !item.classList.contains('open');
      item.classList.toggle('open');
      if (isOpen) {
        button.setAttribute('aria-expanded', 'true');
      } else {
        button.setAttribute('aria-expanded', 'false');
      }

      otherItems.forEach((otherItem) => {
        otherItem.classList.remove('open');
        otherItem
          .querySelector('.accordion__title button')
          .setAttribute('aria-expanded', 'false');
      });
    }

    accordions.forEach((accordion) => {
      Array.from(accordion.children).forEach((item) => {
        if (item.classList.contains('accordion__item')) {
          titles.push(item.querySelector('.accordion__title'));
        }
      });
    });

    titles.forEach((title) => {
      if (context === document) {
        const inner = title.innerHTML;

        // inner has the two extra buttons
        const contentIsVisible = title
          .closest('.accordion__item')
          .querySelector('.accordion__content')
          .getBoundingClientRect().height;
        if (contentIsVisible) {
          title.innerHTML = `<button aria-expanded="true">${inner}</button>`; // eslint-disable-line no-param-reassign
        } else {
          title.innerHTML = `<button aria-expanded="false">${inner}</button>`; // eslint-disable-line no-param-reassign
        }
        title
          .querySelector('button')
          .addEventListener('click', toggleAccordion.bind(title));
      }
    });
  },
};
